import React, { Component } from 'react'
import '../estilospdf.css'

class Cursos extends Component {
  render () {
    return (
        <div clasName='.pdf' style={{ width: '100%', height: '100%'}}>
            <object
            data={require('../docs/certificadosschindler.pdf')}
            type="application/pdf"
            width="100%"
            height="100%">

            </object>
        </div>
    )
  }
}

export default Cursos
